import { HttpService, HttpServiceBase, transformDTODate } from '@skylab-shared/core';
import { Transform } from 'class-transformer';

export type FeatureFlags = FeatureFlagsDTO;
export class FeatureFlagsDTO {
    @Transform(transformDTODate, { toClassOnly: true }) public readonly splitPaymentFeatureReleaseDate: Date;
    @Transform(transformDTODate, { toClassOnly: true }) public readonly receiveKSeFHeadersFromDate: Date;
    @Transform(transformDTODate, { toClassOnly: true }) public readonly issueToInvoiceTinValidationFeatureReleaseDate: Date;
    @Transform(transformDTODate, { toClassOnly: true }) public readonly jpkGroupsMppLawChangesReleaseDate: Date;
    @Transform(transformDTODate, { toClassOnly: true }) public readonly ksef2AvailableDate: Date;
    public readonly ksefDocumentXmlExportFeature: boolean;
    public readonly ksefDocumentXmlImportFeature: boolean;
    public readonly artemisModuleFeature: boolean;
    @Transform((ops: { value: string }) => Number(ops.value)) public readonly expiringLicenseErrorNotificationTerm: number;
    @Transform((ops: { value: string }) => Number(ops.value)) public readonly expiringLicenseWarningNotificationTerm: number;
}

export class FeatureFlagsLoaderBase {
    public constructor(
        private http: HttpService
    ) {}

    public async loadAsync(): Promise<FeatureFlags> {
        try {
            const { data } = await this.http.get('features', { dto: FeatureFlagsDTO });
            return data;
        } catch (err) {
            throw new Error('Feature flags cannot be loaded');
        }
    }
}

export const FeatureFlagsLoader = new FeatureFlagsLoaderBase(HttpServiceBase);
